import React from 'react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

/**
 * The single edit glyph used throughout OLC.
 *
 * Keep contextual color and size at the call site; the icon shape must remain
 * the Material outlined edit glyph.
 */
const OlcEditIcon = ({ size = 20, sx, ...props }) => (
  <EditOutlinedIcon
    {...props}
    sx={[
      {
        fontSize: size,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);

export default OlcEditIcon;
